document.addEventListener('DOMContentLoaded', () => {

  // Reusable function to slide the lines
  function moveSlider(activeBtn, slider) {
    if (!activeBtn || !slider) return;
    slider.style.width = `${activeBtn.offsetWidth}px`;
    slider.style.transform = `translateX(${activeBtn.offsetLeft}px)`;
  }


function buildTable(container, rows) {
  const table = document.createElement('table');
  table.className = 'cg-size-table';

  const thead = document.createElement('thead');
  const tbody = document.createElement('tbody');

  rows.forEach((row, rowIndex) => {
    const cells = row.split('|').map(c => c.trim());

    const tr = document.createElement('tr');

    if (rowIndex === 0) {
      cells.forEach(cell => {
        const th = document.createElement('th');
        th.textContent = cell;
        tr.appendChild(th);
      });
      thead.appendChild(tr);
    } else {
      cells.forEach((cell, i) => {
        const td = document.createElement('td');
        td.textContent = cell;

        if (i === 0) {
          td.classList.add('cg-row-label');
        }

        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    }
  });

  table.appendChild(thead);
  table.appendChild(tbody);

  container.innerHTML = '';
  container.appendChild(table);
}

function initTables() {
  const inchContainer = document.getElementById('table-inch');
  const cmContainer = document.getElementById('table-cm');

  if (inchContainer) {
    const raw = inchContainer.dataset.table;

    if (raw) {
      const rows = raw.split('\n').map(r => r.trim()).filter(Boolean);
      buildTable(inchContainer, rows);
    }
  }

  if (cmContainer) {
    const raw = cmContainer.dataset.table;

    if (raw) {
      const rows = raw.split('\n').map(r => r.trim()).filter(Boolean);
      buildTable(cmContainer, rows);
    }
  }
}

  initTables();

  // --- 1. Master Tab Switching ---
  const tabButtons = document.querySelectorAll('.custom-guide-tab-btn');
  const tabContents = document.querySelectorAll('.custom-guide-tab-content');
  const tabSlider = document.querySelector('.cg-tab-slider');
  const toggleSlider = document.querySelector('.cg-toggle-slider');

  const activeTabBtn = document.querySelector('.custom-guide-tab-btn.active');
  moveSlider(activeTabBtn, tabSlider);

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      tabButtons.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      btn.classList.add('active');
      const targetId = btn.getAttribute('data-target');
      document.getElementById(targetId).classList.add('active');

      moveSlider(btn, tabSlider);

      if (targetId === 'tab-measurements') {
        setTimeout(() => {
          const activeToggleBtn = document.querySelector('.cg-toggle-btn.active');
          moveSlider(activeToggleBtn, toggleSlider);
        }, 10);
      }
    });
  });

  // --- 2. Inch vs CM Toggling ---
  const unitToggles = document.querySelectorAll('.cg-toggle-btn');
  const tableInch = document.getElementById('table-inch');
  const tableCm = document.getElementById('table-cm');

  if (unitToggles.length > 0) {
    const activeToggleBtn = document.querySelector('.cg-toggle-btn.active');
    setTimeout(() => moveSlider(activeToggleBtn, toggleSlider), 100);

    unitToggles.forEach(btn => {
      btn.addEventListener('click', () => {
        unitToggles.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        moveSlider(btn, toggleSlider);

        const unit = btn.getAttribute('data-unit');
        if (unit === 'inch') {
          if (tableInch) tableInch.style.display = 'block';
          if (tableCm) tableCm.style.display = 'none';
        } else {
          if (tableInch) tableInch.style.display = 'none';
          if (tableCm) tableCm.style.display = 'block';
        }
      });
    });
  }

  // --- 3. Accordion Logic for Material Cards ---
  const accordions = document.querySelectorAll('.cg-accordion-trigger');

  accordions.forEach(acc => {
    acc.addEventListener('click', () => {
      const isExpanded = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', !isExpanded);
    });
  });

  // --- 4. Keep sliders aligned on window resize ---
  window.addEventListener('resize', () => {
    moveSlider(document.querySelector('.custom-guide-tab-btn.active'), tabSlider);
    moveSlider(document.querySelector('.cg-toggle-btn.active'), toggleSlider);
  });

});